module.exports = __webpack_public_path__ + "media/src/images/icons/regulation-b53d935fa52c09ed10eb9ead54e16c14.svg";